// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tbo-header__logo[data-v-68487e72]{max-height:3rem}
`, "",{"version":3,"sources":["webpack://./src/modules/tbo/components/TboHeader.vue"],"names":[],"mappings":"AAGE,mCACE,eAAgB","sourcesContent":["\n.tbo-header {\n\n  &__logo {\n    max-height: 3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
